function RandomQuoteGenerator(props) {
  console.log(props)
  const quotes = [
    {text: "No job is complete until a selfie is posted.", author: "Ashok Kallarakkal"},
    {text: "The best way to predict the future is to create it.", author: "Abraham Lincoln"},
    {text: "If opportunity doesn't knock, build a door.", author: "Milton Berle"},
    {text: "The world is your \u{1F9AA}; it's up to you to find the pearls.", author: "Chris Gardner"},
    {text: "It's what you do right now that makes a difference.", author: "Mark Bowden"},
    {text: "You don't need to take all the steps, only the next one.", author: "Unknown"},
    {text: "Boi?", author: "Jordan Lagan"},
    {text: "Obtain the grain.", author: "Kaylee Price"},
    {text: "We're no strangers to love. You know the rules and so do I.", author: "Rick Astley"},
    {text: "Fail fast and cheap.", author: "Roger Parent"},
    {text: "With increased revenue, comes increased heart rate.", author: "Tim Pelletier"},
    {text: "Ignore it for now.", author: "John Zhang"},
    {text: "Do or do not. There is no try.", author: "Yoda"},
    {text: "I like turtles", author: "Jonathan The Zombie"},
    {text: "If you're going through hell, keep going", author: "Winston Churchill"},
    {text: "Walking the dogs, brb!", author: "Mike Harrison"},
    {text: "All we have to decide is what to do with the time that is given us.", author: "Gandalf the Grey"},
    {text: "When you arise in the morning, think of what a precious privilege it is to be alive - to breathe, to think, to enjoy, to love.", author: "Marcus Aurelius"},
    {text: "Just keep swimming.", author: "Dory"}
  ];

  const normalQuotes= [

    {text: "The best way to predict the future is to create it.", author: "Abraham Lincoln"},
    {text: "If opportunity doesn't knock, build a door.", author: "Milton Berle"},
    {text: "The world is your oyster; it's up to you to find the pearls.", author: "Chris Gardner"},
    {text: "It's what you do right now that makes a difference.", author: "Mark Bowden"},
    {text: "You don't need to take all the steps, only the next one.", author: "Unknown"},
    {text: "I attribute my success to this: I never gave or took any excuse.", author: "Florence Nightingale"},
    {text: "Today’s accomplishments were yesterday’s impossibilities.", author: "Robert H. Schuller"},
    {text: "Things may come to those who wait, but only the things left by those who hustle.", author: "Unknown"},
    {text: "When you arise in the morning, think of what a precious privilege it is to be alive - to breathe, to think, to enjoy, to love.", author: "Marcus Aurelius"}
  ];

  const specialQuotes = [
    {text: "oooooOOHH! It's Mista SooFLAY", author: "Jöel Begér", className: "rainbow"}
  ]

  let roll = Math.random() * 100;
  let quote = {};
  if (roll < 1) {
      quote = specialQuotes[Math.floor(Math.random() * specialQuotes.length)];
  } else {
      quote = quotes[Math.floor(Math.random() * quotes.length)];
  }
  if (props.organization.name !== "Digital Position") {
    quote = normalQuotes[Math.floor(Math.random() * normalQuotes.length)];
  }

  return quote
}

export default RandomQuoteGenerator;
